export default {
  header: 'Data Warehourse',
  general: {
    fromDate: 'From Date',
    endDate: 'To Date',
    agentName: 'FC Name',
    customerName: 'Customer Name',
    gender: 'Gender',
    dob: 'Date of Birth',
    agent: 'FC',
    agentCode: 'FC Code',
    team: 'Team',
    teamCode: 'Team Code',
    customer: 'Customer',
    policyType: 'Policy Type',
    lifePolicy: 'Life Policy',
    giPolicy: 'GI Policy',
    export: 'Export',
    status: 'Status',
    workFlowStep: 'Workflow'
  },
  report: {
    header: 'Report',
    applicationStartDate: 'Application Date From',
    applicationEndDate: 'Application Date To',
    customer: {
      customerCode: 'Customer Code',
      header: "Customer Report",
      generalPolicyCount: 'GI Policy Count',
      giPremium: 'GI Premium',
      lifePolicyCount: 'Life Policy Count',
      lifePremium: 'Life Premium',
      country: 'Country',
      nationality: 'Nationality',
      birthDayMonth: 'Birthday Month',
      ageFrom: 'Age From',
      ageTo: 'Age To',
    },
    performance: {
      header: 'Performance Report',
      agentCode: 'FC Code',
      teamCode: 'Team Code',
      premium: 'Premium',
      commission: 'Commission',
      commissionReceivable: 'Commission Receivable',
      cases: 'Cases',
      afyp: 'AFYP',
      fyc: 'FYC',
      ifyp: 'IFYP'
    },
    sale: {
      policyStatus: 'Policy Status',
      premium: 'Premium',
      totalPremiums: 'Total Premium',
      header: 'Sales Report',
      policyNumber: 'Policy Number',
      productName: 'Product Name',
      policyOwner: 'Owner',
      policyType: 'Policy Type',
      premiumType: 'Premium Type',
      provider: 'Provider',
      fyp: 'FYP',
      fyc: 'FYC',
      applicationStartDate: 'Application Date From',
      applicationEndDate: 'Application Date To',

    },
    commission: {
      header: 'Commission',
      policyType: 'Policy Type',
      productCode: 'Product Code',
      commissionAcutalReceived: 'Actual Received',
      faCommission: 'FC Commission',
      policyNumber: 'Policy Number',
      difference: 'Difference'
    },
    birthday: {
      header: 'Customer Birthday Report'
    },
    agentCommission: {
      header: 'FC Commission Report',
    },
    companyCommission: {
      header: 'Company Commission Report',
    },
    renewal: {
      header: 'Renewal Report',
      agent: 'FC Name'
    },
    giPolicy: {
      header: 'GI Report'
    },
    lifePolicy: {
      header: 'Life Report'
    },
    claim:{
      header: 'Claim Report'
    },
    sr:{
      header: 'Service Request Report',
      navHeader: 'SR Report'
    }

  },
  form: {
    header: 'Form Management',
    list: {
      header: 'Form List',
      formCategory: 'Form Category',
      providerName: 'Provider Name',
      formName: 'Form Name',
      deleteModalMsg: 'Are you sure to DELETE this form with details below ?',
    },
    create: {
      header: 'Create Form File',
      formChineseName: 'Form Chinese Name',
      formEnglishName: 'Form English Name',
      formCategory: 'Form Category',
      formLink: 'Form Link',
      provider: 'Provider',
      remarks: 'Remarks',
    },
  }

}



// WEBPACK FOOTER //
// ./src/Dw/langs/en_us/index.js